module.exports = __webpack_public_path__ + "img/banner-z1.b59bfbe5.png";